import * as Yup from "yup";

export const validationSchema = Yup.object().shape({
  selectFrom: Yup.object().nullable().required(),
  dealerSelect: Yup.mixed()
    .nullable()
    .test("is-empty", "Поле обязательно", (value) => {
      if (Array.isArray(value)) return value.length > 0;
      return !!value;
    })
    .required("Поле обязательно"),
  startDate: Yup.date().required(),
  endDate: Yup.date().required(),
});
